module.exports = __webpack_public_path__ + "static/media/USMap.6a510209.svg";